import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header, Toolbar } from 'analysis-ui-components';
import { SvgLogoNmrium } from 'cheminfo-font';
import { useMemo, useCallback, memo } from 'react';
import { FaRegWindowMaximize, FaWrench, FaQuestionCircle, } from 'react-icons/fa';
import { docsBaseUrl } from '../../constants';
import { useChartData } from '../context/ChartContext';
import { usePreferences, useWorkspacesList, } from '../context/PreferencesContext';
import DropDownButton from '../elements/dropDownButton/DropDownButton';
import { useModal, positions } from '../elements/popup/Modal';
import AboutUsModal from '../modal/AboutUsModal';
import GeneralSettings from '../modal/setting/GeneralSettings';
import { options } from '../toolbar/ToolTypes';
import ApodizationOptionsPanel from './ApodizationOptionsPanel';
import AutoPeakPickingOptionPanel from './AutoPeakPickingOptionPanel';
import BaseLineCorrectionPanel from './BaseLineCorrectionPanel';
import ManualPhaseCorrectionPanel from './ManualPhaseCorrectionPanel';
import RangesPickingOptionPanel from './RangesPickingOptionPanel';
import ZeroFillingOptionsPanel from './ZeroFillingOptionsPanel';
import Zones2DOptionPanel from './Zones2DOptionPanel';
function HeaderInner(props) {
    const { isFullscreen, onMaximize = () => null, selectedOptionPanel } = props;
    const modal = useModal();
    const { current: { display: { general }, }, workspace, dispatch, } = usePreferences();
    const workspacesList = useWorkspacesList();
    const hideGeneralSettings = !!(general?.hideGeneralSettings && workspace.base);
    const selectedPanel = useMemo(() => {
        switch (selectedOptionPanel) {
            case options.apodization.id:
                return _jsx(ApodizationOptionsPanel, {});
            case options.zeroFilling.id:
                return _jsx(ZeroFillingOptionsPanel, {});
            case options.phaseCorrection.id:
                return _jsx(ManualPhaseCorrectionPanel, {});
            case options.peakPicking.id:
                return _jsx(AutoPeakPickingOptionPanel, {});
            case options.rangePicking.id:
                return _jsx(RangesPickingOptionPanel, {});
            case options.baselineCorrection.id:
                return _jsx(BaseLineCorrectionPanel, {});
            case options.zonePicking.id:
                return _jsx(Zones2DOptionPanel, {});
            default:
                break;
        }
    }, [selectedOptionPanel]);
    const openGeneralSettingsHandler = useCallback(() => {
        modal.show(_jsx(GeneralSettings, {}), {
            position: positions.MIDDLE,
            enableResizing: true,
            width: 600,
            height: 400,
        });
    }, [modal]);
    const openAboutUs = useCallback(() => {
        modal.show(_jsx(AboutUsModal, {}), {
            isBackgroundBlur: false,
            position: positions.MIDDLE,
            width: 500,
            height: 480,
        });
    }, [modal]);
    const changeWorkspaceHandler = useCallback((option) => {
        dispatch({
            type: 'SET_WORKSPACE',
            payload: {
                workspace: option.key,
            },
        });
    }, [dispatch]);
    return (_jsxs(Header, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }, children: [_jsx("div", { children: _jsx(Toolbar, { orientation: "horizontal", children: _jsx(Toolbar.Item, { onClick: openAboutUs, titleOrientation: "horizontal", id: "logo", title: "About NMRium", children: _jsx("div", { style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: _jsx(SvgLogoNmrium, {}) }) }) }) }), _jsx("div", { className: "toolOptionsPanel", children: selectedPanel })] }), _jsxs("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }, children: [!hideGeneralSettings && (_jsx(DropDownButton, { data: workspacesList, selectedKey: workspace.current, onSelect: changeWorkspaceHandler })), _jsx("div", { children: _jsxs(Toolbar, { orientation: "horizontal", children: [_jsx(Toolbar.Item, { id: "user-manual", title: "User manual", onClick: () => window.open(docsBaseUrl, '_blank'), children: _jsx(FaQuestionCircle, {}) }), !hideGeneralSettings && (_jsx(Toolbar.Item, { id: "general-settings", onClick: openGeneralSettingsHandler, title: "General settings", children: _jsx(FaWrench, {}) })), !isFullscreen && (_jsx(Toolbar.Item, { id: "full-screen", onClick: onMaximize, title: "Full Screen", className: "windowButton", children: _jsx(FaRegWindowMaximize, {}) }))] }) })] })] }));
}
const MemoizedHeader = memo(HeaderInner);
export default function HeaderWrapper({ isFullscreen, onMaximize }) {
    const { toolOptions: { selectedOptionPanel }, } = useChartData();
    return (_jsx(MemoizedHeader, { ...{
            selectedOptionPanel,
            isFullscreen,
            onMaximize,
        } }));
}
